import { all } from 'redux-saga/effects';

import StatisticsSaga from '../App/containers/statistics/statistics.saga';
import LoginSaga from '../App/containers/login/login.saga';
import AdminSaga from '../App/containers/admin/admin.saga';
import RankingSaga from '../App/containers/ranking/ranking.saga';

export default function* RootSaga() {
  yield all([
      StatisticsSaga(),
      LoginSaga(),
      AdminSaga(),
      RankingSaga()
  ]);
}




// WEBPACK FOOTER //
// ./src/config/root-saga.js